module.exports = __webpack_public_path__ + "img/friend_off.81e220bf.svg";